import { Prop, Component, Vue } from 'vue-property-decorator';
import { normalizeComponent } from 'vue-runtime-helpers';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ default: 'bed' })
    ], default_1.prototype, "iconName", void 0);
    __decorate([
        Prop({ default: '1em' })
    ], default_1.prototype, "width", void 0);
    __decorate([
        Prop({ default: '1em' })
    ], default_1.prototype, "height", void 0);
    __decorate([
        Prop({ default: 'currentColor' })
    ], default_1.prototype, "iconColor", void 0);
    default_1 = __decorate([
        Component
    ], default_1);
    return default_1;
}(Vue));

/* script */
const __vue_script__ = default_1;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 42 42",
        "aria-labelledby": _vm.iconName,
        role: "presentation"
      }
    },
    [
      _c("g", { attrs: { fill: _vm.iconColor } }, [
        _c("path", {
          attrs: {
            d:
              "M41.16 31.5H0.84C0.42 31.5 0 31.92 0 32.34V41.16C0 41.58 0.42 42 0.84 42H3.78C3.99 42 4.2 42 4.41 41.79L8.19 38.01C8.4 37.8 8.61 37.8 8.82 37.8H33.39C33.6 37.8 33.81 37.8 34.02 38.01L37.8 41.79C37.8 42 38.01 42 38.22 42H41.16C41.58 42 42 41.58 42 41.16V32.34C42 31.92 41.58 31.5 41.16 31.5Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M1.25831 29.4H40.5283C41.1583 29.4 41.5783 28.77 41.3683 28.14L37.7983 21V2.1C37.7983 0.84 36.9583 0 35.6983 0C34.4383 0 33.5983 0.84 33.5983 2.1V6.3C25.1983 3.57 16.7983 3.57 8.39831 6.3V2.1C8.39831 0.84 7.55831 0 6.29831 0C5.03831 0 4.19831 0.84 4.19831 2.1V21L0.628311 28.14C0.418311 28.77 0.628311 29.4 1.25831 29.4ZM23.0983 15.54C23.0983 15.12 23.5183 14.7 23.9383 14.7H32.7583C33.1783 14.7 33.5983 15.12 33.5983 15.54V20.16C33.5983 20.58 33.1783 21 32.7583 21H23.9383C23.5183 21 23.0983 20.58 23.0983 20.16V15.54ZM8.39831 15.54C8.39831 15.12 8.81831 14.7 9.23831 14.7H18.0583C18.4783 14.7 18.8983 15.12 18.8983 15.54V20.16C18.8983 20.58 18.4783 21 18.0583 21H9.23831C8.81831 21 8.39831 20.58 8.39831 20.16V15.54Z"
          }
        })
      ])
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
